module.exports = __webpack_public_path__ + "assets/img/5_1279.c8a7ac9f.jpg";